/**
 * Palette catégorielle des graphes de l'onglet Général.
 *
 * Les deux premières portent Entrant et Sortant, la paire qu'on lit le plus
 * souvent, en deux variantes du vert Leedflow. À teinte quasi identique, c'est
 * la CLARTÉ qui les sépare : 29 % contre 58 %, soit 29 points d'écart. Deux verts choisis à luminosité voisine seraient impossibles à
 * distinguer dans une barre empilée, là où deux teintes différentes pardonnent.
 *
 * Les trois suivantes ne servent que sur l'onglet Plateforme, à bonne distance
 * du vert. Toutes sont assez saturées pour tenir sur fond clair comme sur fond
 * sombre.
 *
 * Le rouge reste réservé aux appels en défaut, seule série qui alerte.
 */
/** Violet du Réceptionniste IA : ni GSM ni VoIP, c'est une troisième nature. */
export const AI_RECEPTIONIST_VIOLET = '#7C3AED';

export const CATEGORICAL_COLORS = [
  '#15803D', // vert profond
  '#4ADE80', // vert clair
  '#EA580C', // orange
  '#0891B2', // cyan
  '#64748B', // ardoise
];

// Users map ramp. Fixed steps: a filter must never repaint the surviving points.
export const MAP_HEAT_STEPS = [
  { from: 1, label: '1' },
  { from: 2, label: '2-4' },
  { from: 5, label: '5-9' },
  { from: 10, label: '10+' },
];

// Light surface: density darkens.
export const MAP_HEAT_LIGHT = ['#34C759', '#17A44A', '#0B7A38', '#055124'];

// Dark surface: density lightens, a deep green would vanish.
export const MAP_HEAT_DARK = ['#0F7A38', '#159944', '#34C759', '#8FE9B0'];
